import React from 'react';
import CompanySettings from './CompanySettings';
import { useTranslation } from 'react-i18next';
import '../css/Settings.css';

const Settings = () => {
  const { t } = useTranslation();
  return (
    <div className="settings-container">
      <div className="settings-main-only">
        <div className="settings-content">
          <div className="page-header">
            <h1>{t("admin.setting.title")}</h1>
            <p>{t("admin.setting.subtitle")}</p>
          </div>
          <CompanySettings />
        </div>
      </div>
    </div>
  );
};

export default Settings;